/**
 * This Function will be used as a marker for gulp-angular-gettext to extract the string to the pot file
 *  @param {*} str string that need to be translated
 */

export const gettext = str => str;
